import * as actions  from "@/store/graph/types"
import { act, sync } from "@/store/lib/APIRequest"

export default {
  [actions.ENSURE_JSON_DOCUMENT_EXISTS]:  (context, patch)    => sync(context, actions.ENSURE_JSON_DOCUMENT_EXISTS, patch),
  [actions.PATCH_JSON_DOCUMENT]:          (context, patch)    => act(context, actions.PATCH_JSON_DOCUMENT, patch),

}
